import { render, staticRenderFns } from "./RestaurantAdminView.vue?vue&type=template&id=6075dd7a&scoped=true&"
import script from "./RestaurantAdminView.vue?vue&type=script&lang=js&"
export * from "./RestaurantAdminView.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantAdminView.vue?vue&type=style&index=0&id=6075dd7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6075dd7a",
  null
  
)

export default component.exports